import Base64Image from "./Base64Image";

export default function ShowVideo(props: any) {
  const getEmbedUrl = (url: any) => {
    if (!url) return "";

    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;

    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;

    return url;
  };
  const getVideoId = (url: string): string => {
    const match = url.match(/(?:youtube\.com.*v=|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : "";
  };

  return (
    <div className="container p-0 border">
      <div className="w-100" style={{}}>
        <div className="row mx-auto px-2 ">
          <div className="col-12">
            <div className="row d-flex align-items-end">
              <div className="col-8" style={{ borderBottom: `1px solid ${props.primaryColor}` }}>
                <h4 className="fw-bold" style={{ color: `${props.primaryColor}` }}>
                  Video
                </h4>
              </div>
              <div className="col-4" style={{ paddingTop: "5rem" }}></div>
            </div>
          </div>
          <div className="col-12 my-4 text-center">
            <div className="d-flex justify-content-center">
              <div className="position-relative" style={{ width: "100%", maxWidth: "650px" }}>
                <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden", borderRadius: "8px" }}>
                  {!props.isGeneratingPdf && props.videoUrl && (
                    <iframe
                      src={getEmbedUrl(props.videoUrl)}
                      title="Insurance Proposal Video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: "none",
                        borderRadius: "8px",
                      }}
                    ></iframe>
                  )}

                  {props.isGeneratingPdf && props.videoUrl && (
                    <a
                      href={props.videoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block position-relative "
                      style={{ height: "400px" }}
                    >
                      <Base64Image
                        imageUrl={`https://img.youtube.com/vi/${getVideoId(props.videoUrl)}/0.jpg` || ""}
                        className="qp-downloaded-video rounded"
                        alt="Insurance Image"
                      />
                      <i className="fa fa-play-circle position-absolute top-50 start-50 translate-middle text-white" style={{ fontSize: "4rem" }}></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
